import * as Yup from "yup";

export const ValidationSchema = (t?: any) =>
    Yup.object().shape({
        name: Yup.string().required("Name is required!").min(1).max(128),
        coachName: Yup.string().required("Coach Name is required!").min(1),
    });
